import React, { lazy, Suspense } from 'react';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';

const StandaloneFicheDePrep = lazy(() => import('./index'));

export default function LoadableStandaloneFicheDePrep() {
  return (
    <Suspense fallback={<ScreenSpinner />}>
      <StandaloneFicheDePrep />
    </Suspense>
  );
}
